module.exports = __webpack_public_path__ + "img/support_sys.26c701c0.png";